import { Environment } from '../environments';
import { buildBiwApiRootUri } from './buildBiwApiRootUri';
import { buildUri } from './utils/buildUri';

const COMPANY_SETUP_PATH = '/v1/company-setup';

export const buildCompanyListUri = ( env ) => (
    buildUri(
        [ buildBiwApiRootUri( env ), COMPANY_SETUP_PATH, '/graphql' ],
        { env: ( env !== Environment.PROD ) ? env : '' },
    )
);
